import React from 'react';
import { Spinner } from 'react-bootstrap';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'danger' | 'success' | 'warning' | 'info';
    size?: 'sm' | 'md' | 'lg';
    isLoading?: boolean;
    leftIcon?: React.ReactNode;
    rightIcon?: React.ReactNode;
    fullWidth?: boolean;
    iconOnly?: boolean;
}

const Button: React.FC<ButtonProps> = ({
    children,
    variant = 'primary',
    size = 'md',
    isLoading = false,
    leftIcon,
    rightIcon,
    fullWidth = false,
    className = '',
    disabled,
    ...props
}) => {
    const baseClass = 'btn';

    // Map variants to Bootstrap/Custom classes
    const variantClasses = {
        primary: 'btn-primary',
        secondary: 'btn-secondary',
        outline: 'btn-outline-primary',
        ghost: 'btn-link text-decoration-none',
        danger: 'btn-danger',
        success: 'btn-success',
        warning: 'btn-warning',
        info: 'btn-info'
    };

    const sizeClasses = {
        sm: 'btn-sm',
        md: '',
        lg: 'btn-lg'
    };

    const classes = [
        baseClass,
        variantClasses[variant],
        sizeClasses[size],
        fullWidth ? 'w-100' : '',
        props.iconOnly ? 'btn-icon d-inline-flex align-items-center justify-content-center' : '',
        className
    ].filter(Boolean).join(' ');

    return (
        <button
            className={classes}
            disabled={disabled || isLoading}
            {...props}
        >
            {isLoading && (
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                />
            )}
            {!isLoading && leftIcon && <span className="me-2 d-flex align-items-center">{leftIcon}</span>}
            {children}
            {!isLoading && rightIcon && <span className="ms-2 d-flex align-items-center">{rightIcon}</span>}
        </button>
    );
};

export default Button;
